module.exports = __webpack_public_path__ + "img/newFlagHost.3d61a098.jpeg";